import request from "../utils/request";

//获取列表
export function getAppList(params) {
  return request({
    url: `/app/list?pageNum=${params.currentPage}&pageSize=${params.currentPageSize}&appNameOrBundle=${params.appOrBundleId}&system=${params.platform}`,
    method: "get"
  });
}
//更具id查询列表
export function getAppById(params) {
  return request({
    url: `/app/query?id=${params.id}`,
    method: "get"
  });
}
//新建应用
export function createApp(params) {
  return request({
    url: "/app/add",
    method: "post",
    data: {
      appCO: {
        name: params.appName,
        bundleId: params.bundleId,
        pictureFormat:params.pictureFormat,
        icon: params.icon,
        system: params.platform,
        storeUrl: params.storeLink,
        appKey: params.appKey,
        dataSetWords: params.dynamicTags.join(","),
        comment: params.desc,
        domainName:params.domainName,
        cdnPrefix:params.cdnPrefix,
        packageList:params.packageList
      }
    }
  });
}

//删除应用
export function deleteApp(params) {
  return request({
    url: "/app/delete",
    method: "post",
    data: {
      id: params.id
    }
  });
}

//更新应用
export function editApp(params,id) {
  return request({
    url: "/app/update",
    method: "post",
    data: {
      appCO: {
        id,
        name: params.appName,
        bundleId: params.bundleId,
        pictureFormat:params.pictureFormat,
        icon: params.icon,
        system: params.platform,
        storeUrl: params.storeLink,
        appKey: params.appKey,
        dataSetWords: params.dynamicTags.join(","),
        comment: params.desc,
        domainName:params.domainName,
        cdnPrefix:params.cdnPrefix,
        packageList:params.packageList
      }
    }
  });
}
